import React from "react";
import { Link } from "react-router-dom";

class ProductLogsContainer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            logs: [],
            barcode: ""
        }

        this.renderActionLogs = this.renderActionLogs.bind(this);
    }

    componentDidMount() {
        const { logs, barcode } = this.props.product;
        this.setState({ logs, barcode });
    }

    renderActionLogs(log) {
        const rows = [];

        for (const logAction of log.actions) {
            const key = `${log.boxID}-${logAction.action}`
            const locationWithLink = logAction.location.includes('@') ?
                <Link target="_blank" to={`/closet-hackers/${log.userID}`}>{logAction.location}</Link> : logAction.location;

            rows.push(
                <tr key={key}>
                    <td>{logAction.date}</td>
                    <td>{logAction.action}</td>
                    <td>{locationWithLink}</td>
                </tr>
            );
        }

        return rows;
    }

    render() {
        const { logs } = this.state;
        /**
         * return empty view if there is no logs
         * for this product.
         */
        if (!logs.length) {
            return (
                <section className="hero is-light">
                    <div className="hero-body">
                        <p className="subtitle">
                            <span className="icon"><i className="fas fa-heart-broken"></i></span> No logs available for this product.
                        </p>
                    </div>
                </section>
            )
        }

        return (
            <>
                <div className="container">

                    <table className="table is-striped is-fullwidth">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Update</th>
                                <th>Location</th>
                            </tr>
                        </thead>
                        <tbody>
                            {logs.map((log) => (
                                this.renderActionLogs(log)
                            ))}
                        </tbody>
                    </table>
                </div>
            </>
        );
    }
}

export default ProductLogsContainer;
